export default [
  {
    'area': '新世界ゲート',
    'attributes':{
      '綱': '案内所'
    },
    'description': '',
    'id': 10000,
    'image': 'img/facilities/img_10000_01.jpg',
    'info': '',
    'lat': 34.650707,
    'lng': 135.507682,
    'name': '案内所',
    'type': 1000
  },
  {
    'area': 'てんしばゲート',
    'attributes':{
      '綱': '案内所'
    },
    'description': '',
    'id': 10001,
    'image': 'img/facilities/img_10001_01.jpg',
    'info': '',
    'lat': 34.649132,
    'lng': 135.509231,
    'name': '案内所',
    'type': 1000
  },
  {
    'area': '多目的広場付近',
    'attributes':{
      '綱': '化粧室'
    },
    'description': '',
    'id': 10100,
    'image': 'img/facilities/img_10100_01.jpg',
    'info': '',
    'lat': 34.651133,
    'lng': 135.509523,
    'name': '化粧室',
    'type': 1001
  },
  {
    'area': 'オオカミ舎とトラ舎の間',
    'attributes':{
      '綱': '化粧室'
    },
    'description': '',
    'id': 10101,
    'image': 'img/facilities/img_10101_01.jpg',
    'info': '',
    'lat': 34.652973,
    'lng': 135.509253,
    'name': '化粧室',
    'type': 1001
  },
  {
    'area': 'ハイエナの舎向かい',
    'attributes':{
      '綱': '化粧室'
    },
    'description': '',
    'id': 10102,
    'image': 'img/facilities/img_10102_01.jpg',
    'info': '',
    'lat': 34.652627,
    'lng': 135.507931,
    'name': '化粧室',
    'type': 1001
  },
  {
    'area': 'カバ舎・ツル舎の向かい',
    'attributes':{
      '綱': '化粧室'
    },
    'description': '',
    'id': 10103,
    'image': 'img/facilities/img_10103_01.jpg',
    'info': '',
    'lat': 34.651354,
    'lng': 135.508251,
    'name': '化粧室',
    'type': 1001
  },
  {
    'area': '新世界ゲート',
    'attributes':{
      '綱': '化粧室'
    },
    'description': '',
    'id': 10104,
    'image': 'img/facilities/img_10104_01.jpg',
    'info': '',
    'lat': 34.650735,
    'lng': 135.507208,
    'name': '化粧室',
    'type': 1001
  },
  {
    'area': 'アシカ池・フクロウ舎の間',
    'attributes':{
      '綱': '化粧室'
    },
    'description': '',
    'id': 10105,
    'image': 'img/facilities/img_10105_01.jpg',
    'info': '',
    'lat': 34.649814,
    'lng': 135.50715,
    'name': '化粧室',
    'type': 1001
  },
  {
    'area': '南門出口',
    'attributes':{
      '綱': '化粧室'
    },
    'description': '',
    'id': 10106,
    'image': 'img/facilities/img_10106_01.jpg',
    'info': '',
    'lat': 34.649323,
    'lng': 135.506773,
    'name': '化粧室',
    'type': 1001
  },
  {
    'area': 'ヒヒハウスの裏',
    'attributes':{
      '綱': '化粧室'
    },
    'description': '',
    'id': 10107,
    'image': 'img/facilities/img_10107_01.jpg',
    'info': '',
    'lat': 34.650414,
    'lng': 135.508652,
    'name': '化粧室',
    'type': 1001
  },
  {
    'area': 'コアラ館の向かい',
    'attributes':{
      '綱': '化粧室'
    },
    'description': '',
    'id': 10108,
    'image': 'img/facilities/img_10108_01.jpg',
    'info': '',
    'lat': 34.649502,
    'lng': 135.508546,
    'name': '化粧室',
    'type': 1001
  },
  {
    'area': '多目的広場付近',
    'attributes':{
      '綱': 'ベビーチェア・ベビーベッド'
    },
    'description': '',
    'id': 10200,
    'image': 'img/facilities/img_10200_01.jpg',
    'info': '',
    'lat': 34.651145,
    'lng': 135.509539,
    'name': 'ベビーチェア・ベビーベッド',
    'type': 1002
  },
  {
    'area': '新世界ゲート',
    'attributes':{
      '綱': 'ベビーチェア・ベビーベッド'
    },
    'description': '',
    'id': 10201,
    'image': 'img/facilities/img_10201_01.jpg',
    'info': '',
    'lat': 34.650695,
    'lng': 135.507183,
    'name': 'ベビーチェア・ベビーベッド',
    'type': 1002
  },
  {
    'area': 'アシカ池・フクロウ舎の間',
    'attributes':{
      '綱': 'ベビーチェア・ベビーベッド'
    },
    'description': '',
    'id': 10202,
    'image': 'img/facilities/img_10202_01.jpg',
    'info': '',
    'lat': 34.649803,
    'lng': 135.507186,
    'name': 'ベビーチェア・ベビーベッド',
    'type': 1002
  },
  {
    'area': 'オオカミ舎・トラ舎の間',
    'attributes':{
      '綱': 'ベビーチェア・ベビーベッド'
    },
    'description': '',
    'id': 10203,
    'image': 'img/facilities/img_10203_01.jpg',
    'info': '',
    'lat': 34.652937,
    'lng': 135.509255,
    'name': 'ベビーチェア・ベビーベッド',
    'type': 1002
  },
  {
    'area': 'ハイエナ舎の向かい',
    'attributes':{
      '綱': 'ベビーチェア・ベビーベッド'
    },
    'description': '',
    'id': 10204,
    'image': 'img/facilities/img_10204_01.jpg',
    'info': '',
    'lat': 34.652582,
    'lng': 135.507918,
    'name': 'ベビーチェア・ベビーベッド',
    'type': 1002
  },
  {
    'area': 'カバ舎・ツル舎の向かい',
    'attributes':{
      '綱': 'ベビーチェア・ベビーベッド'
    },
    'description': '',
    'id': 10205,
    'image': 'img/facilities/img_10205_01.jpg',
    'info': '',
    'lat': 34.651346,
    'lng': 135.508292,
    'name': 'ベビーチェア・ベビーベッド',
    'type': 1002
  },
  {
    'area': '南門出口',
    'attributes':{
      '綱': 'ベビーチェア・ベビーベッド'
    },
    'description': '',
    'id': 10206,
    'image': 'img/facilities/img_10206_01.jpg',
    'info': '',
    'lat': 34.649276,
    'lng': 135.506762,
    'name': 'ベビーチェア・ベビーベッド',
    'type': 1002
  },
  {
    'area': 'ヒヒハウスの裏',
    'attributes':{
      '綱': 'ベビーチェア・ベビーベッド'
    },
    'description': '',
    'id': 10207,
    'image': 'img/facilities/img_10207_01.jpg',
    'info': '',
    'lat': 34.650382,
    'lng': 135.508637,
    'name': 'ベビーチェア・ベビーベッド',
    'type': 1002
  },
  {
    'area': 'コアラ舎の向かい',
    'attributes':{
      '綱': 'ベビーチェア・ベビーベッド'
    },
    'description': '',
    'id': 10208,
    'image': 'img/facilities/img_10208_01.jpg',
    'info': '',
    'lat': 34.649516,
    'lng': 135.50863,
    'name': 'ベビーチェア・ベビーベッド',
    'type': 1002
  },
  {
    'area': '多目的広場付近',
    'attributes':{
      '綱': '多目的トイレ'
    },
    'description': '',
    'id': 10300,
    'image': 'img/facilities/img_10300_01.jpg',
    'info': '',
    'lat': 34.651111,
    'lng': 135.50951,
    'name': '多目的トイレ',
    'type': 1003
  },
  {
    'area': '新世界ゲート',
    'attributes':{
      '綱': '多目的トイレ'
    },
    'description': '',
    'id': 10301,
    'image': 'img/facilities/img_10301_01.jpg',
    'info': '',
    'lat': 34.650658,
    'lng': 135.507202,
    'name': '多目的トイレ',
    'type': 1003
  },
  {
    'area': 'オオカミ舎・トラ舎の間',
    'attributes':{
      '綱': '多目的トイレ'
    },
    'description': '',
    'id': 10302,
    'image': 'img/facilities/img_10302_01.jpg',
    'info': '',
    'lat': 34.653003,
    'lng': 135.509247,
    'name': '多目的トイレ',
    'type': 1003
  },
  {
    'area': 'ハイエナ舎の向かい',
    'attributes':{
      '綱': '多目的トイレ'
    },
    'description': '',
    'id': 10303,
    'image': 'img/facilities/img_10303_01.jpg',
    'info': '',
    'lat': 34.652527,
    'lng': 135.507902,
    'name': '多目的トイレ',
    'type': 1003
  },
  {
    'area': 'カバ舎・ツル舎の向かい',
    'attributes':{
      '綱': '多目的トイレ'
    },
    'description': '',
    'id': 10304,
    'image': 'img/facilities/img_10304_01.jpg',
    'info': '',
    'lat': 34.651338,
    'lng': 135.508342,
    'name': '多目的トイレ',
    'type': 1003
  },
  {
    'area': '新世界ゲート付近',
    'attributes':{
      '綱': '多目的トイレ'
    },
    'description': '',
    'id': 10305,
    'image': 'img/facilities/img_10305_01.jpg',
    'info': '',
    'lat': 34.651053,
    'lng': 135.507399,
    'name': '多目的トイレ',
    'type': 1003
  },
  {
    'area': 'ヒヒハウスの裏',
    'attributes':{
      '綱': '多目的トイレ'
    },
    'description': '',
    'id': 10306,
    'image': 'img/facilities/img_10306_01.jpg',
    'info': '',
    'lat': 34.650442,
    'lng': 135.508661,
    'name': '多目的トイレ',
    'type': 1003
  },
  {
    'area': 'レッサーパンダショップ',
    'attributes':{
      '綱': '飲食・売店'
    },
    'description': '',
    'id': 10400,
    'image': 'img/facilities/img_10400_01.jpg',
    'info': '',
    'lat': 34.65205,
    'lng': 135.509125,
    'name': '飲食・売店',
    'type': 1004
  },
  {
    'area': 'ホッキョクグマ舎の向かい',
    'attributes':{
      '綱': '飲食・売店'
    },
    'description': '',
    'id': 10401,
    'image': 'img/facilities/img_10401_01.jpg',
    'info': '',
    'lat': 34.649607,
    'lng': 135.507565,
    'name': '飲食・売店',
    'type': 1004
  },
  {
    'area': '新世界ゲート',
    'attributes':{
      '綱': 'コインロッカー'
    },
    'description': '',
    'id': 10500,
    'image': 'img/facilities/img_10500_01.jpg',
    'info': '',
    'lat': 34.650865,
    'lng': 135.507706,
    'name': 'コインロッカー',
    'type': 1005
  },
  {
    'area': '新世界ゲート',
    'attributes':{
      '綱': 'ベビーカート貸出'
    },
    'description': '',
    'id': 10600,
    'image': 'img/facilities/img_10600_01.jpg',
    'info': '',
    'lat': 34.650617,
    'lng': 135.507628,
    'name': 'ベビーカート貸出',
    'type': 1006
  },
  {
    'area': 'サスティナブルガーデン内',
    'attributes':{
      '綱': '休憩所'
    },
    'description': '',
    'id': 10700,
    'image': 'img/facilities/img_10700_01.jpg',
    'info': '',
    'lat': 34.651466,
    'lng': 135.509548,
    'name': '休憩所',
    'type': 1007
  },
  {
    'area': '鳥の楽園前の庭園内',
    'attributes':{
      '綱': '休憩所'
    },
    'description': '',
    'id': 10701,
    'image': 'img/facilities/img_10701_01.jpg',
    'info': '',
    'lat': 34.649133,
    'lng': 135.50863,
    'name': '休憩所',
    'type': 1007
  },
  {
    'area': '多目的広場付近',
    'attributes':{
      '綱': 'オストメイト'
    },
    'description': '',
    'id': 10800,
    'image': 'img/facilities/img_10800_01.jpg',
    'info': '',
    'lat': 34.651117,
    'lng': 135.509549,
    'name': 'オストメイト',
    'type': 1008
  },
  {
    'area': 'ヒヒハウスの裏',
    'attributes':{
      '綱': 'オストメイト'
    },
    'description': '',
    'id': 10801,
    'image': 'img/facilities/img_10801_01.jpg',
    'info': '',
    'lat': 34.650396,
    'lng': 135.508676,
    'name': 'オストメイト',
    'type': 1008
  },
  {
    'area': 'ハイエナ舎の向かい',
    'attributes':{
      '綱': 'オストメイト'
    },
    'description': '',
    'id': 10802,
    'image': 'img/facilities/img_10802_01.jpg',
    'info': '',
    'lat': 34.652573,
    'lng': 135.507947,
    'name': 'オストメイト',
    'type': 1008
  },
  {
    'area': '新世界ゲート',
    'attributes':{
      '綱': 'オストメイト'
    },
    'description': '',
    'id': 10803,
    'image': 'img/facilities/img_10803_01.jpg',
    'info': '',
    'lat': 34.650673,
    'lng': 135.507161,
    'name': 'オストメイト',
    'type': 1008
  },
  {
    'area': 'レクチャールーム入口付近',
    'attributes':{
      '綱': '救護室'
    },
    'description': '',
    'id': 10900,
    'image': 'img/facilities/img_10900_01.jpg',
    'info': '',
    'lat': 34.650771,
    'lng': 135.508716,
    'name': '救護室',
    'type': 1009
  },
  {
    'area': 'レクチャールーム入口付近',
    'attributes':{
      '綱': '授乳室'
    },
    'description': '',
    'id': 11000,
    'image': 'img/facilities/img_11000_01.jpg',
    'info': '',
    'lat': 34.650814,
    'lng': 135.508582,
    'name': '授乳室',
    'type': 1010
  },
  {
    'area': '新世界ゲート',
    'attributes':{
      '綱': '料金所'
    },
    'description': '',
    'id': 11100,
    'image': 'img/facilities/img_11100_01.jpg',
    'info': '',
    'lat': 34.65074,
    'lng': 135.507681,
    'name': '料金所',
    'type': 1011
  },
  {
    'area': 'てんしばゲート',
    'attributes':{
      '綱': '料金所'
    },
    'description': '',
    'id': 11101,
    'image': 'img/facilities/img_11101_01.jpg',
    'info': '',
    'lat': 34.649119,
    'lng': 135.509319,
    'name': '料金所',
    'type': 1011
  },
  {
    'area': '新世界ゲート付近',
    'attributes':{
      '綱': '喫煙所'
    },
    'description': '',
    'id': 11200,
    'image': 'img/facilities/img_11200_01.jpg',
    'info': '',
    'lat': 34.651084,
    'lng': 135.507411,
    'name': '喫煙所',
    'type': 1012
  },
  {
    'area': '猛きん舎の向かい(高架下)',
    'attributes':{
      '綱': '喫煙所'
    },
    'description': '',
    'id': 11201,
    'image': 'img/facilities/img_11201_01.jpg',
    'info': '',
    'lat': 34.653667,
    'lng': 135.508173,
    'name': '喫煙所',
    'type': 1012
  },
  {
    'area': '南門出口',
    'attributes':{
      '綱': '喫煙所'
    },
    'description': '',
    'id': 11202,
    'image': 'img/facilities/img_11202_01.jpg',
    'info': '',
    'lat': 34.649148,
    'lng': 135.506777,
    'name': '喫煙所',
    'type': 1012
  },
  {
    'area': 'キジ舎の横(高架下)',
    'attributes':{
      '綱': 'バス駐車場'
    },
    'description': '',
    'id': 11300,
    'image': 'img/facilities/img_11300_01.jpg',
    'info': '',
    'lat': 34.649834,
    'lng': 135.506975,
    'name': 'バス駐車場',
    'type': 1013
  },
  {
    'area': '新世界ゲート',
    'attributes':{
      '綱': '展示室'
    },
    'description': '',
    'id': 11400,
    'image': 'img/facilities/img_11400_01.jpg',
    'info': '',
    'lat': 34.650665,
    'lng': 135.507385,
    'name': '展示室',
    'type': 1014
  },

];


// WEBPACK FOOTER //
// ./map/js/ih/extend/FacilityData.js